import { getColor } from '../../colors/colors.alias';
import { getFontWeight, getFontFamily, getLineHeight, getFontSize, } from '../../typography/typography.alias';
import { constants as Subtext } from '../Subtext';
import { VARIANT_FORM, VARIANT_FORM_SECONDARY, VARIANT_LIST_ITEM, VARIANT_ATTENTIONAL_LIST_ITEM, VARIANT_PROGRESS_INDICATOR_CATEGORY, VARIANT_SUB_LABEL, VARIANT_TERM, ELEMENT_LABEL, ELEMENT_SUBTEXT, DATA_STATE_SELECTED, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'Label',
    variants: {
        VARIANT_FORM,
        VARIANT_FORM_SECONDARY,
        VARIANT_LIST_ITEM,
        VARIANT_ATTENTIONAL_LIST_ITEM,
        VARIANT_PROGRESS_INDICATOR_CATEGORY,
        VARIANT_SUB_LABEL,
        VARIANT_TERM,
    },
    elements: {
        ELEMENT_LABEL,
        ELEMENT_SUBTEXT,
    },
    dataStates: {
        DATA_STATE_SELECTED,
    },
});
export default function getLabel(transformer, config) {
    const color = getColor(transformer, config);
    const fontFamily = getFontFamily(transformer, config);
    const fontSize = getFontSize(transformer);
    const lineHeight = getLineHeight(transformer);
    const fontWeight = getFontWeight(transformer);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_LABEL]: {
                styles: {
                    fontFamily: fontFamily.body.value,
                    fontSize: fontSize.body.m.value,
                    lineHeight: lineHeight.body.get(fontSize.body.m.value),
                    color: color.text.default.value,
                },
                dataStates: {
                    [DATA_STATE_SELECTED]: {
                        styles: {
                            color: color.label.dataStates[DATA_STATE_SELECTED].value,
                        },
                    },
                },
                variants: {
                    [VARIANT_FORM]: {
                        styles: {
                            fontFamily: fontFamily.form.label.value,
                            fontWeight: fontWeight.form.label.get(fontFamily.form.label.value),
                        },
                    },
                    [VARIANT_ATTENTIONAL_LIST_ITEM]: {
                        styles: {
                            fontFamily: fontFamily.listItem.attentional.value,
                            fontWeight: fontWeight.listItem.attentional.get(fontFamily.listItem.attentional.value),
                        },
                    },
                    [VARIANT_SUB_LABEL]: {
                        styles: {
                            color: color.text.subtle.value,
                        },
                    },
                    [VARIANT_TERM]: {
                        styles: {
                            fontFamily: fontFamily.term.value,
                            fontWeight: fontWeight.term.get(fontFamily.term.value),
                            color: color.text.subtle.value,
                        },
                    },
                },
            },
            [ELEMENT_SUBTEXT]: {
                variants: {
                    [VARIANT_LIST_ITEM]: {
                        components: {
                            [Subtext.NAME]: {
                                variant: Subtext.variants.VARIANT_SMALL,
                            },
                        },
                    },
                },
                components: {
                    [Subtext.NAME]: {
                        variant: Subtext.variants.VARIANT_MEDIUM,
                    },
                },
            },
        },
    });
}
